module.exports = __webpack_public_path__ + "static/img/zhongzhuan.677bd22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhongzhuan.png
// module id = 3MsW
// module chunks = 1